const buttons = {
    BUY:"خرید",
    SEE_EDUCATION:"مشاهده آموزش",
    TO_HOME:"بازگشت به صفحه اصلی",
    ANDROID:"اپلیکیشن اندروید",
    BTN_SEPERATOR:" | ",
    EXTRA_URL:"دانلود فایل کمکی",
}

export default buttons;